module.exports = __webpack_public_path__ + "img/background-about.7697571b.jpg";